import AdminDashboard from './Dashboard';
import Proposal from './Proposal';
import Mail from './Mail';
import TaskMonitor from './TaskMonitor';
import blogRoutes from './Blog/routes';
import { ADMIN_TYPES } from 'config/adminTypes';

export const path = '/admin/dashboard';

const routes = [
  {
    name: 'Mail',
    path: `${path}/mail/*`,
    icon: '',
    component: Mail,
    allowedAdminTypes: [ADMIN_TYPES.COMMUNICATION, ADMIN_TYPES.SUPER_USER],
  },
  {
    name: 'Proposal',
    path: `${path}/proposal/*`,
    icon: '',
    component: Proposal,
    allowedAdminTypes: [ADMIN_TYPES.DATA_ADMIN, ADMIN_TYPES.SUPER_USER],
  },
  {
    name: 'Task Monitor',
    path: `${path}/task-monitor/*`,
    icon: '',
    component: TaskMonitor,
    allowedAdminTypes: [ADMIN_TYPES.DATA_ADMIN, ADMIN_TYPES.SUPER_USER],
  },
  // Spread blog routes directly into the admin routes
  ...blogRoutes.map(route => ({
    ...route,
    allowedAdminTypes: [ADMIN_TYPES.DATA_ADMIN, ADMIN_TYPES.SUPER_USER],
  })),
  {
    name: 'Dashboard',
    path: `${path}`,
    icon: '',
    component: AdminDashboard,
    allowedAdminTypes: Object.values(ADMIN_TYPES),
    exact: true,
  },
];

export const redirects = [
  {
    from: `${path}`,
    to: `${path}`,
  },
  {
    from: `${path}/*`,
    to: `${path}`,
  },
];

export default routes;
